<div class="card ml-2 mr-2 mt-2"
     (click)="onSelectObjectTemplate(objectTemplate);"
     [ngClass]="{'shadow border-left': shadow, 
                'text-white bg-secondary': selectedObjectTemplate?.name === objectTemplate?.name && selectedObjectTemplate?.collection === objectTemplate?.collection}"
     (mouseover)="changeStyle($event)"
     (mouseout)="changeStyle($event)"
     [attr.role]="'button'">
  <div class="card-body p-2">
    <div class="w-100" style="overflow: hidden;">
      <span class="card-title h6 mb-0">{{objectTemplate.name}} &nbsp;</span><br>
      <span class="card-text mb-0">{{objectTemplate.collection}} &nbsp;</span><br>
    </div>
    <span class="card-text">
      Dimensioni: 
      ({{objectTemplate.dimension.height | number}}&times;
      {{objectTemplate.dimension.width | number}}&times;
      {{objectTemplate.dimension.depth | number}})
    </span>
  </div>
</div>